import { Trans } from '@lingui/macro'
import React from 'react'
import { Checkbox, InputField, Option, Typography } from 'webbook-airways'

export default function InputFieldProperties({
  notRequired,
  category,
  properties: init_properties,
  onSelect = () => {},
}) {
  const { name, min_selected, max_selected, property_category_id } =
    category || {}
  const properties = init_properties
  const required = !notRequired && min_selected > 0
  if (properties?.length === 0) {
    return (
      <Typography style={{ padding: '10px 15px' }}>
        <Trans>No options found</Trans>
      </Typography>
    )
  }
  if (properties?.length === 1) {
    const property = properties[0] || {}
    return (
      <Checkbox
        required={required}
        checked={property.property_value}
        onChange={() => onSelect(property.property_id, property_category_id)}
      >
        {property.name}
      </Checkbox>
    )
  }
  if (max_selected > 1) {
    return (
      <Multiselect
        label={name}
        required={required}
        min={min_selected}
        max={max_selected}
        category={category}
        properties={properties}
        onSelect={onSelect}
      />
    )
  }
  const selected_property =
    properties.find((property) => property.property_value === true) || {}
  return (
    <InputField
      required={required}
      label={name}
      value={selected_property.property_id}
      onChange={(event) => onSelect(event.target.value, property_category_id)}
    >
      {properties.map((property) => (
        <Option key={property.property_id} value={property.property_id}>
          {property.name}
        </Option>
      ))}
    </InputField>
  )
}

function Multiselect({
  label,
  required,
  min,
  max,
  category,
  properties,
  onSelect,
}) {
  function handleSelect(property_id, property_category_id) {
    if (
      properties.filter((property) => property.property_value)?.length < max ||
      properties.some(
        (property) =>
          property.property_id === property_id && property.property_value,
      )
    ) {
      onSelect(property_id, property_category_id)
    }
  }
  return (
    <React.Fragment>
      <Typography
        variant="caption"
        style={{ fontSize: 10, marginLeft: 15, marginTop: 7.5 }}
      >
        {label} ({min}-{max} <Trans>options</Trans>)
      </Typography>
      {properties.map((property) => (
        <Checkbox
          key={property.property_id}
          checked={property.property_value}
          onChange={() =>
            handleSelect(property.property_id, category.property_category_id)
          }
        >
          {property.name}
        </Checkbox>
      ))}
    </React.Fragment>
  )
}
